module.exports = vendor_6aa64253ccde40c7997d;